// src/components/ai/MessageBubble.js
import React from 'react';
import { Link } from 'react-router-dom';
import { BsCopy } from 'react-icons/bs';
import BookCard from '../library/BookCard';
import VerticalContentCard from '../Category/VerticalContentCard';

// حذف ایموجی‌های متنی
function removeEmoji(text) {
  if (!text) return '';
  return text.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
}

const CARD_LINK_REGEX = /(?:🎓|📚|🎙️|-)?\s*\[([^\]]+)\]\((\/(?:products|books|media)\/[^)]+)\)/g;
const PAGE_LINK_REGEX = /\[([^\]]+)\]\((\/[^)]+)\)/g;

function stripHtml(str) {
  return str.replace(/<[^>]*>/g, '');
}

function parseMessageContent(rawContent) {
  const content = stripHtml(rawContent);
  const blocks = [];
  const lines = content.split('\n');
  let textBuffer = [];
  let currentCards = [];

  const flushText = () => {
    const txt = textBuffer.join('\n').trim();
    if (txt) blocks.push({ type: 'text', value: txt });
    textBuffer = [];
  };
  const flushCards = () => {
    if (currentCards.length) {
      blocks.push({ type: 'cards', items: currentCards });
      currentCards = [];
    }
  };

  for (const line of lines) {
    CARD_LINK_REGEX.lastIndex = 0;
    const cardMatch = CARD_LINK_REGEX.exec(line);
    if (cardMatch) {
      flushText();
      currentCards.push({
        title: cardMatch[1].trim(),
        url: cardMatch[2].trim(),
        itemType: cardMatch[2].startsWith('/books/') ? 'book' : 'product',
      });
      continue;
    }
    flushCards();
    PAGE_LINK_REGEX.lastIndex = 0;
    const pageMatch = PAGE_LINK_REGEX.exec(line);
    if (pageMatch) {
      const before = line.slice(0, pageMatch.index).trim();
      if (before) textBuffer.push(before);
      flushText();
      blocks.push({ type: 'link', title: pageMatch[1].trim(), url: pageMatch[2].trim() });
      const after = line.slice(pageMatch.index + pageMatch[0].length).trim();
      if (after) textBuffer.push(after);
    } else {
      textBuffer.push(line);
    }
  }
  flushText();
  flushCards();
  return blocks;
}

// استخراج slug از url
const extractSlug = (url) => {
  if (!url) return '';
  const parts = url.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
};

export default function MessageBubble({ message, getToken }) {
  const isUser = message.role === 'user';
  const blocks = isUser
    ? [{ type: 'text', value: message.content }]
    : parseMessageContent(message.content);

  const textBlocks = blocks.filter(b => b.type !== 'cards');
  const cardBlocks = blocks.filter(b => b.type === 'cards');
  const serverCards = message.cards || [];

  // لاگ‌های اصلی
  console.log('📦 message:', message);
  console.log('📦 serverCards:', serverCards);
  console.log('📦 textBlocks:', textBlocks);
  console.log('📦 cardBlocks:', cardBlocks);

  // 🔍 لاگ‌های دقیق ساختار اولین کارت کتاب و محصول
  if (serverCards.length > 0) {
    const firstBook = serverCards.find(
      c => c.type === 'book' || (c.uri || c.url || '').includes('/books/')
    );
    const firstProduct = serverCards.find(
      c => c.type !== 'book' && !(c.uri || c.url || '').includes('/books/')
    );
    if (firstBook) {
      console.log('🔬 First serverCard (book):', JSON.stringify(firstBook, null, 2));
    }
    if (firstProduct) {
      console.log('🔬 First serverCard (product):', JSON.stringify(firstProduct, null, 2));
    }
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`w-fit max-w-[88%] rounded-2xl px-4 py-3 shadow-lg ${
          isUser
            ? 'bg-white/40 backdrop-blur-lg border border-white/50 text-gray-900 rounded-br-sm'
            : 'bg-white/30 backdrop-blur-lg border border-blue-200/50 neon-glow text-gray-800 rounded-bl-sm'
        }`}
      >
        <div className="flex justify-between items-center mb-1.5 text-[11px] opacity-60 gap-4">
          <span className="font-semibold">{isUser ? 'شما' : 'فرزانه'}</span>
          {!isUser && message.content && (
            <button onClick={() => copyToClipboard(message.content)} className="hover:opacity-100">
              <BsCopy size={12} />
            </button>
          )}
        </div>

        {/* مراحل تفکر */}
        {!isUser && message.thinkingSteps?.length > 0 && (
          <div className="flex flex-col gap-1.5 mb-2 text-xs text-gray-700">
            {message.thinkingSteps.map((s, i) => (
              <div key={i} className="flex items-center gap-2 px-3 py-1.5 bg-white/20 backdrop-blur-md rounded-full border border-white/30 shadow-sm">
                <span>{s.content}</span>
              </div>
            ))}
          </div>
        )}

        {/* متن و لینک‌ها (پاکسازی‌شده از ایموجی) */}
        <div className="text-[12px] leading-7 font-light text-right">
          {textBlocks.map((block, i) => {
            if (block.type === 'link') {
              return (
                <Link key={i} to={block.url} className="inline-flex items-center gap-1 text-blue-600 underline underline-offset-2 hover:text-blue-800 transition-colors text-sm">
                  {removeEmoji(block.title)}
                </Link>
              );
            }
            return (
              <div key={i} className="whitespace-pre-wrap break-words" style={{ overflowWrap: 'anywhere' }}>
                {removeEmoji(block.value)}
              </div>
            );
          })}
        </div>

        {/* کارت‌های استخراج‌شده از مارک‌داون */}
        {!isUser && cardBlocks.map((block, i) => (
          <div key={i} className="flex flex-col gap-3 my-3 w-full">
            {block.items.map((item, idx) => {
              const slug = extractSlug(item.url);
              if (item.itemType === 'book') {
                return (
                  <BookCard
                    key={idx}
                    book={{
                      slug,
                      title: item.title,
                      cover_image_url: null,
                      author: null,
                      translator: null,
                      publisher: null,
                      tags: [],
                    }}
                  />
                );
              }
              return (
                <VerticalContentCard
                  key={idx}
                  data={{
                    slug,
                    title: item.title,
                    cover_url: null,
                    description: '',
                    price_display: '',
                    is_free: false,
                    product_url: item.url,
                  }}
                />
              );
            })}
          </div>
        ))}

        {/* کارت‌های ارسالی از سرور */}
        {!isUser && serverCards.length > 0 && (
          <div className="flex flex-col gap-3 my-3 w-full">
            {serverCards.map((c, idx) => {
              const cardUrl = c.uri || c.url || '';
              const slug = extractSlug(cardUrl);
              const isBook = c.type === 'book' || cardUrl.includes('/books/');

              if (isBook) {
                return (
                  <BookCard
                    key={idx}
                    book={{
                      slug,
                      title: c.title || 'بدون عنوان',
                      cover_image_url: c.cover_image_url || c.cover_url || null,
                      author: c.author || null,
                      translator: c.translator || null,
                      publisher: c.publisher || null,
                      tags: c.tags || [],
                    }}
                  />
                );
              }
              return (
                <VerticalContentCard
                  key={idx}
                  data={{
                    slug,
                    title: c.title || 'بدون عنوان',
                    cover_url: c.cover_url || null,
                    description: c.summary || c.description || '',
                    price_display: c.price_display || '',
                    is_free: c.is_free || false,
                    product_url: cardUrl,
                  }}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}